import { faPen as faPenSolid } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@mui/material';

import Icon from '../Icon/Icon';
import { EditButton, Label, LabelStyles, SummaryRowStyles } from './Summary.styles';

type Props = {
    label: string;
    value: string;
    showEditButton?: boolean;
};

const SummaryRow = ({ label, value, showEditButton }: Props) => {
    return (
        <SummaryRowStyles>
            <LabelStyles>
                <Label>{label}</Label>
                <span>{value}</span>
            </LabelStyles>
            {showEditButton ? (
                <Button variant="text" sx={EditButton}>
                    <Icon icon={faPenSolid} color={'#1A1E218A'} size="sm" />
                </Button>
            ) : null}
        </SummaryRowStyles>
    );
};

export default SummaryRow;
